<div class="challenge-fly-wrapper">
  <ng-lottie
    [options]="lottieOptions"
    [styles]="lottieBoxStyles"
    (animationCreated)="onLottieCreated($event)"
  ></ng-lottie>
</div>
